module.exports = __webpack_public_path__ + "static/img/23037N_1_V_20230821_LC.c15a05c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/23037N_1_V_20230821_LC.png
// module id = Hn8E
// module chunks = 0